import { Pipe, PipeTransform } from '@angular/core';

import { LocaleService } from '../services/locale.service';
import { UnitSystem, UnitConversionValueWithUnitOnly, FsTemperatureOptions } from '../types/unit-system';
import { UnitConverter } from '../utils/unit-conversion';
import { UnitConversionBasePipe } from './unit-conversion-base.pipe';

const DEFAULT_TEMPERATURE_OPTIONS: Required<FsTemperatureOptions> = {
  precision: 0,
  includeUnit: true,
  sourceUnit: 'imperial',
};

@Pipe({
  name: 'fsTemperature',
  pure: true,
})
export class FsTemperaturePipe extends UnitConversionBasePipe implements PipeTransform {
  constructor(_localeService: LocaleService) {
    super(_localeService);
  }

  transform(value: UnitConversionValueWithUnitOnly, options?: FsTemperatureOptions | number): string {
    const opts = typeof options === 'number' 
      ? { ...DEFAULT_TEMPERATURE_OPTIONS, precision: options }
      : { ...DEFAULT_TEMPERATURE_OPTIONS, ...options };
    
    return this.convertAndFormat(
      value, 
      opts.precision, 
      opts.includeUnit, 
      opts.sourceUnit, 
      UnitConverter.convertTemperature, 
      (system) => this._localeService.getUnitConfig().temperature.symbol, 
      ''
    );
  }
}

